var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.875,
    cy: 4.875,
    r: 1.875,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4.875,
    r: 1.875,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.125,
    cy: 4.875,
    r: 1.875,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.875,
    cy: 12,
    r: 1.875,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1.875,
    fill: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.125,
    cy: 12,
    r: 1.875,
    fill: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.875,
    cy: 19.125,
    r: 1.875,
    fill: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 19.125,
    r: 1.875,
    fill: "black"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.125,
    cy: 19.125,
    r: 1.875,
    fill: "black"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.4375,
    cy: 8.4375,
    r: 1.875,
    fill: "black"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.75,
    cy: 8.4375,
    r: 1.875,
    fill: "black"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.4375,
    cy: 15.375,
    r: 1.875,
    fill: "black"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.75,
    cy: 15.375,
    r: 1.875,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCement);
export default __webpack_public_path__ + "static/media/Cement.69a597c233a6c85abd864cc50843d662.svg";
export { ForwardRef as ReactComponent };